import { render, staticRenderFns } from "./tronscanTransferTrx.vue?vue&type=template&id=5b5d2332&scoped=true"
import script from "./tronscanTransferTrx.vue?vue&type=script&lang=js"
export * from "./tronscanTransferTrx.vue?vue&type=script&lang=js"
import style0 from "./tronscanTransferTrx.vue?vue&type=style&index=0&id=5b5d2332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d2332",
  null
  
)

export default component.exports